import { AbstractConfDataCommand } from "./abstractConfDataCommand";

export class ConfDeleteCommand extends AbstractConfDataCommand {
}